import { RoomId, roomId, StreamId, streamId } from "@common/domain";
import { JsonSchemaValidator } from "@common/json-schema-validator";

export class RoomStreamActiveDeleteRequestDTO {
  private static validation = JsonSchemaValidator.compile(
    RoomStreamActiveDeleteRequestDTO.validationSchema()
  );

  constructor(readonly data: RoomStreamActiveDeleteRequest) {
    JsonSchemaValidator.assert(
      RoomStreamActiveDeleteRequestDTO.validation,
      data
    );
  }

  private static validationSchema() {
    return {
      type: "object",
      required: ["roomId", "streamId"],
      properties: {
        roomId,
        streamId
      }
    };
  }
}

interface RoomStreamActiveDeleteRequest {
  roomId: RoomId;
  streamId: StreamId;
}
